import { render, staticRenderFns } from "./NotaExplicativaDR.vue?vue&type=template&id=b7ae8b4a"
import script from "./NotaExplicativaDR.vue?vue&type=script&lang=js"
export * from "./NotaExplicativaDR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports